import { render, staticRenderFns } from "./SelectBackgroundModal.vue?vue&type=template&id=8bf1778c&"
import script from "./SelectBackgroundModal.vue?vue&type=script&lang=ts&"
export * from "./SelectBackgroundModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports